<template>
  <ul id="headerMenuId" class="navbar-nav">
    <li class="nav-item b-nav-dropdown dropdown show">
      <ul v-if="showMenu"
        tabindex="-1"
        class="dropdown-menu show"
        style="
          position: absolute;
          top: -20px;
          right: 2px;
        "
      >
        <li>
          <router-link class="dropdown-item" to="/account" @click="toggleLoginMenuIfNoCtrl">
            マイページ
          </router-link>
        </li>
        <li>
          <router-link class="dropdown-item" :to="'/' + $root.account.info.userName" @click="toggleLoginMenuIfNoCtrl">
            公開プロフィール
          </router-link>
        </li>
        <li>
          <button
            @click="toggleLoginMenu();$root.logoutDialog.open()"
            type="button"
            class="dropdown-item"
          >
            ログアウト
          </button>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import accountState from '@/state/AccountState';
import CommonHeaderTitle from "@/logic/CommonHeaderTitle"
import { FMSetLayout} from '@/interface/kiwi/ForkstyleMessage';
import urls from '@/URLs';
const ID_HEADER_USER = "header-user"
@Options({
  components: {
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  public headerTitle = new CommonHeaderTitle();
  showMenu = false;
  loginButton = window.document.getElementById("header-login") as HTMLButtonElement
  loginedUserButton = window.document.getElementById(ID_HEADER_USER) as HTMLButtonElement
  uploadLink = window.document.getElementById("header-upload") as HTMLAnchorElement

  toggleLoginMenu() {
    this.showMenu = !this.showMenu
  }
  toggleLoginMenuIfNoCtrl(e:MouseEvent) {
    if(!e.ctrlKey){
      this.toggleLoginMenu()
    }
  }
  closeLoginMenu(event:any) {
    if(this.showMenu && event.target){
      if(event.target.id !== ID_HEADER_USER && !event.target.closest("#headerMenuId")){
        this.showMenu = false
      }
    }
  }

  created(){    
    this.addOnClickToAtag("header-home", "/")
    this.addOnClickToAtag("header-search", "/search")
    this.addOnClickToUpload()
    this.addOnClickToLogin()
    this.addOnClickToUser()
    accountState.addLoginListener(this.switchHeaderButtons)
    
    window.addEventListener('click', this.closeLoginMenu);
  }

  
  addOnClickToAtag(id:string, url:string){
    var elm = window.document.getElementById(id) as HTMLAnchorElement
    elm.href = url
    elm.addEventListener("click", (e:MouseEvent)=>{
      this.$root.routerPushOnLink(e, url)
    })
  }

  addOnClickToUpload(){
    this.uploadLink.addEventListener("click", (e:MouseEvent)=>{
        this.$root.routerPushOnLink(e, this.getUploadUrl())
    })
  }

  addOnClickToLogin(){
    this.loginButton.addEventListener("click", (e:Event)=>{
        this.$root.loginDialog.open()
        e.preventDefault();
    })
  }
  addOnClickToUser(){
    this.loginedUserButton.addEventListener("click", (e:Event)=>{
      this.toggleLoginMenu()
      e.preventDefault();
    })
  }
  
  switchHeaderButtons(){
    if(accountState.isLogin){
      this.loginButton.style.display = "none"
      this.loginedUserButton.innerHTML = accountState.info.userName
      this.loginedUserButton.style.display = "initial"
    }else{
      this.loginButton.style.display = "initial"
      this.loginedUserButton.style.display = "none"
    }

    this.uploadLink.href = this.getUploadUrl()
  }
  

  getUploadUrl(){
    if(accountState.isLogin && accountState.info.hasProject){
      return "/account/project"
    }else{
      return urls.getUploadFileURL()
    }
  }


  getHeaderHeight(){
    //ヘッダーの高さはwindow幅で変わるので、get化しない
    const header = document.getElementById("forksyle-header");
    return header ? header.offsetHeight : 0;
  }
  
  setBackground(data:FMSetLayout){
    const header = document.getElementById("forksyle-header");
    if(header){
      header.style.background = data.headerBackGround
    }
  }
  clearBackground(){
    const header = document.getElementById("forksyle-header");
    if(header){
      header.style.background = ""
    }
  }
}
</script>

<style lang="scss" scoped>

/* navbar  */
.navigationBar {
  background-color: white;

}

.header-center{
  margin: auto;
  cursor: pointer;
  overflow: hidden;
  user-select: none;
  min-width: 10px;
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.btn-small-padding{
  white-space: nowrap;
  padding-top: .16rem;
  padding-bottom: .16rem;
}

.nav-div{
  display: flex;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  padding-right: 5%;
  padding-left: 5%;
  align-items: center;
  margin-bottom: 0;
}

.search{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}


@media (max-width: 768px) {
  .search {
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .upload{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
@media (max-width: 576px) {
  .nav-div{
    padding-right: 2%;
    padding-left: 2%;
  }
  .search {
    margin-left: 0.2rem;
    margin-right: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
  .upload{
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
}
@media (max-width: 450px) {
  .nav-div{
    padding-right: 4px;
    padding-left: 4px;
  }
  .search {
    margin-left: 0.1rem;
    margin-right: 0.1rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }
  .upload{
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }
}
@media (max-width: 320px) {

}

.navbar-nav .dropdown-menu {
    position: static;
    float: none;
}
.navbar-nav {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    margin-top: 0;
}
.dropdown-item {
    display: block;
    width: 100%;
    padding: .25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
    text-decoration: none;
}
.dropdown-menu {
    position: absolute;
    z-index: 1000;
    display: none;
    min-width: 10rem;
    padding: .5rem 0;
    margin: .125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: .25rem;
}
.dropdown-menu.show {
    display: block;
    li:hover{
        background-color:#eee;
        transition: background-color 0.2s;

    }
}
</style>
